import React from 'react';
import { FormRadio, RadioGroup, TextField } from '@tryhackme/thm-ui-components';
import { Controller, useFormContext } from 'src/common/form';
import { ManageRoomDetail } from 'src/features/manage-room/manage-room.types';
import { useGetUserQuery } from 'src/common/slices';
import { isInternalContentDev } from 'src/common/helpers';
import { FormRow } from '../../../form-row';
import { SettingCard } from '../../../setting-card';
import { RoomCodeConfirmModal } from '../room-code-confirm-modal';
import { THMRoomTypeOptions } from '../../general-settings.constants';
import { StyledGeneralSectionContainer, StyledBottomAdornment, StyledMinutesText, StyledTimeToCompletetInputWrapper, StyledTimeToCompleteInput, StyledRoomCodeInput, StyledRadioGroup } from './general-section.styles';
export const GeneralSection = () => {
  const {
    register,
    control,
    formState: {
      errors,
      dirtyFields
    }
  } = useFormContext<ManageRoomDetail>();
  const {
    data: userData
  } = useGetUserQuery();

  // @TODO: Refactor - remove content-dev - https://tryhackme.atlassian.net/browse/PLAT-540
  const isContentDev = isInternalContentDev(userData?.data?.user);
  const [isRoomCodeInputEnabled, setIsRoomCodeInputEnabled] = React.useState<boolean>(true);
  const handleEnableRoomCodeInput = () => {
    setIsRoomCodeInputEnabled(false);
  };
  React.useEffect(() => {
    if (!dirtyFields?.code) {
      setIsRoomCodeInputEnabled(Boolean(!dirtyFields?.code));
    }
  }, [dirtyFields?.code]);
  return <StyledGeneralSectionContainer aria-label="Room General Settings" data-sentry-element="StyledGeneralSectionContainer" data-sentry-component="GeneralSection" data-sentry-source-file="general-section.tsx">
      <SettingCard data-sentry-element="SettingCard" data-sentry-source-file="general-section.tsx">
        <FormRow heading="Title" description="What do you want to call this room?" data-sentry-element="FormRow" data-sentry-source-file="general-section.tsx">
          <TextField {...register('title')} data-testid="title" id="title" variant="input" label="Title" isRequired maxLength={30} bottomAdornment={<StyledBottomAdornment>Max character count is 30.</StyledBottomAdornment>} errorMessage={errors?.title?.message} data-sentry-element="TextField" data-sentry-source-file="general-section.tsx" />
        </FormRow>

        <FormRow heading="Description" description="Add a short description explaining what this room covers and who it is suitable for." data-sentry-element="FormRow" data-sentry-source-file="general-section.tsx">
          <TextField {...register('description')} id="description" data-testid="description" variant="textarea" label="Description" isRequired maxLength={250} bottomAdornment={<StyledBottomAdornment>Max character count is 250.</StyledBottomAdornment>} errorMessage={errors?.description?.message} data-sentry-element="TextField" data-sentry-source-file="general-section.tsx" />
        </FormRow>

        <FormRow heading="Room code" description={`The code people use to enter your room. The room code determines the room's url, so updating it will invalidate the current URL. If you have shared room links with people, you will have to update them.`} data-sentry-element="FormRow" data-sentry-source-file="general-section.tsx">
          <StyledRoomCodeInput {...register('code')} id="code" data-testid="code" variant="input" label="Room code" isRequired autoComplete="off" isDisabled={isRoomCodeInputEnabled} rightOutsideAdornment={<RoomCodeConfirmModal handleEnableRoomCodeInput={handleEnableRoomCodeInput} isDisabled={!isRoomCodeInputEnabled} />} errorMessage={errors?.code?.message} data-sentry-element="StyledRoomCodeInput" data-sentry-source-file="general-section.tsx" />
        </FormRow>
        {isContentDev && <FormRow heading="Created by" description="The room creator is preset unless updated by a Content Engineer.">
            <Controller control={control} name="roomCreatorType" render={({
          field: {
            onChange,
            value
          }
        }) => <RadioGroup legend="">
                  <StyledRadioGroup>
                    {THMRoomTypeOptions.map(input => <FormRadio key={input.id} onChange={onChange} id={input.id} label={input.label} value={input.value} name={input.name} checked={input.value === value} />)}
                  </StyledRadioGroup>
                </RadioGroup>} />
          </FormRow>}

        <FormRow heading="Room completion time" description="Estimate how long it will take users to complete the room." showBottomLine={false} data-sentry-element="FormRow" data-sentry-source-file="general-section.tsx">
          <StyledTimeToCompletetInputWrapper data-sentry-element="StyledTimeToCompletetInputWrapper" data-sentry-source-file="general-section.tsx">
            <StyledTimeToCompleteInput {...register('timeToComplete')} id="timeToComplete" data-testid="time-completion" label="Completion time" variant="input" type="number" isRequired rightOutsideAdornment={<StyledMinutesText>minutes</StyledMinutesText>} errorMessage={errors?.timeToComplete?.message} data-sentry-element="StyledTimeToCompleteInput" data-sentry-source-file="general-section.tsx" />
          </StyledTimeToCompletetInputWrapper>
        </FormRow>
      </SettingCard>
    </StyledGeneralSectionContainer>;
};